import { render } from "./WelcomeBack.vue?vue&type=template&id=0963521c&scoped=true"
import script from "./WelcomeBack.vue?vue&type=script&lang=js"
export * from "./WelcomeBack.vue?vue&type=script&lang=js"

import "./WelcomeBack.vue?vue&type=style&index=0&id=0963521c&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3621675308/src/competition/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0963521c"]])

export default __exports__